import { Observable } from 'rxjs';
import { Component, OnInit, Input, ContentChildren, QueryList, ViewChild, ElementRef, TemplateRef, AfterViewInit, ChangeDetectorRef, Output, EventEmitter, HostBinding, ContentChild } from '@angular/core';
import { Subscription } from 'rxjs';
@Component({
  selector: 'panel',
  inputs: ['id', 'label', 'active'],
  template: `<ng-content></ng-content>`
})
export class PanelComponent {
  @Input() id: string;
  @Input() label: string;
  @Input() @ViewChild(TemplateRef) label2: TemplateRef<any>;
  @Input() icon: string;
  @Input() active: boolean;
  @Input() disabled: boolean;
  @Input() step: boolean;
  @Input() @ViewChild(TemplateRef) content: TemplateRef<any>;
}

@Component({
  selector: 'panel-switch',
  templateUrl: './panel-switch.component.html',
  styleUrls: ['./panel-switch.component.scss']
})
export class PanelSwitchComponent implements AfterViewInit, OnInit {

  constructor(private cdRef: ChangeDetectorRef) { }
  totalPanel: number;
  activePanel: number;
  @Input()
  goToNext: Observable<number>;
  @Input() counterActive
  @Input() steps = false
  @Input() autoHeight = true
  @Input() theme
  @Output() onEnableAddButton: EventEmitter<any> = new EventEmitter<any>()
  @Input() checkEnableAddButton: EventEmitter<any> = new EventEmitter<any>()
  @Output() bounce: EventEmitter<any> = new EventEmitter<any>()
  @HostBinding('class.steps') get isSteps() {
    return this.steps;
  }
  @ContentChildren(PanelComponent) panelsRefs: QueryList<PanelComponent>
  nexSubscription: Subscription;
  ngAfterViewInit(): void {
    this.panels = this.panelsRefs.toArray();
    this.totalPanel = this.panels.length;
    if (this.panels) {
      let pane = this.panels[0]
      if (pane) {
        this.activePanel = 0;
        this.activateTab(pane)
      }
    }
    this.cdRef.detectChanges();
  }
  ngOnInit() {
    if (this.goToNext) {
      this.nexSubscription = this.goToNext.subscribe(
        () => {
          this.next()
        }
      )
      this.checkEnableAddButton.subscribe(
        () => {
          // let p=this.panels[this.activePanel].panels2.toArray()[0];
          // if (p.activePanel == p.totalPanel - 1) {
          //   this.onEnableAddButton.emit(true);
          // }
        }
      )
    }
  }
  panels: PanelComponent[]
  @ViewChild('tabs') tabs: ElementRef;

  activateTab(panel: PanelComponent) {
    if (panel && panel.active) {
      return
    }
    this.bounceFunction();
    panel.active = true;
    this.onEnableAddButton.emit(false);
    this.panels.forEach((p, index) => {
      if (p.id !== panel.id) {
        p.active = false
      } else {
        this.activePanel = index;
        setTimeout(
          () => {
            if (this.activePanel == this.totalPanel - 1) {
              this.onEnableAddButton.emit(true);
            }
          }, 100
        )
      }
    })
  }
  next() {
    if (this.activePanel < this.totalPanel) {
      // if (this.panels[this.activePanel].panels2 && this.panels[this.activePanel].panels2.toArray().length > 0) {
      //   let p = this.panels[this.activePanel].panels2.toArray()[0];
      //   if (this.activePanel == this.totalPanel - 1) {
      //     p.activePanel++;
      //     p.activateTab(p.panels[p.activePanel]);
      //     if (p.activePanel == p.totalPanel - 1) {
      //       this.onEnableAddButton.emit(true);
      //     }
      //   } else {
      //     if (p.activePanel == p.totalPanel - 1) {
      //       this.activePanel++;
      //       this.activateTab(this.panels[this.activePanel]);
      //     } else {
      //       p.activePanel++;
      //       p.activateTab(p.panels[p.activePanel]);
      //     }
      //   }
      // } else {
      this.activePanel++;
      this.activateTab(this.panels[this.activePanel]);
      // }
    }
  }
  ngOnDestroy() {
    if (this.nexSubscription) this.nexSubscription.unsubscribe()
  }
  bounceFunction() {
    this.bounce.emit(true);
  }
}